// extracted by mini-css-extract-plugin
export var container = "_ec-0";
export var icon = "_ec-1";
export var text = "_ec-2";